var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basil:check-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0199 5.31322C12.1136 5.40697 12.1662 5.53405 12.1662 5.66655C12.1662 5.79905 12.1136 5.92614 12.0199 6.01989L7.35327 10.6866C7.25952 10.7802 7.13244 10.8328 6.99994 10.8328C6.86744 10.8328 6.74036 10.7802 6.64661 10.6866L3.97994 8.01989C3.93081 7.97411 3.89141 7.91891 3.86409 7.85758C3.83676 7.79624 3.82206 7.73004 3.82088 7.6629C3.81969 7.59577 3.83204 7.52908 3.85719 7.46682C3.88234 7.40456 3.91977 7.34801 3.96725 7.30053C4.01473 7.25305 4.07128 7.21562 4.13354 7.19047C4.1958 7.16532 4.26249 7.15297 4.32962 7.15416C4.39676 7.15534 4.46297 7.17004 4.5243 7.19736C4.58563 7.22469 4.64083 7.26409 4.68661 7.31322L6.99994 9.62655L11.3133 5.31322C11.407 5.21959 11.5341 5.16699 11.6666 5.16699C11.7991 5.16699 11.9262 5.21959 12.0199 5.31322Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0d2f7b42883e1650cf086d8b31c34a9b.svg";
export { ForwardRef as ReactComponent };